/**
 * One-sentence textual summary of the current chart state, used as the canvas
 * `aria-label` so screen-reader users get the numbers without the visual.
 * Rebuilt on every config change.
 */
import type { Units } from "./config";
import { fmtLD, fmtSink, fmtSpeed } from "./format";
import type { PolarOutputs } from "./outputs";

export const buildChartSummary = (
  gliderName: string,
  outputs: PolarOutputs,
  units: Units,
  wingLoadingFactor: number,
): string => {
  const { minSink, bestLD, speedToFly, xcSpeed } = outputs;
  const stf =
    speedToFly !== null
      ? `speed-to-fly ${fmtSpeed(speedToFly.v_kmh, units)}`
      : "speed-to-fly unavailable (MC tangent has no solution)";
  const xc =
    xcSpeed !== null ? `XC speed ${fmtSpeed(xcSpeed.vGround_kmh, units)}` : "XC speed unavailable";

  return (
    `Polar curve for ${gliderName} at wing loading ${wingLoadingFactor.toFixed(2)}: ` +
    `min sink ${fmtSink(minSink.w_ms, units)} at ${fmtSpeed(minSink.v_kmh, units)}, ` +
    `best L/D ${fmtLD(bestLD.ld)}, ${stf}, ${xc}.`
  );
};
